import { useEffect, useRef } from 'react';

const SCROLL_DEBOUNCE_TIME = 150; // milliseconds to wait after scroll stops

export const useScrollAnimation = (): React.RefObject<HTMLDivElement> => {
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    const element = elementRef.current;

    if (!element) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Clear any existing timeout
            if (timeoutId) clearTimeout(timeoutId);

            // Set new timeout to add animation class after scroll stops
            timeoutId = setTimeout(() => {
              element.classList.add('animate');
            }, SCROLL_DEBOUNCE_TIME);
          }
        });
      },
      {
        threshold: 0.2, // Trigger when 20% of element is visible
      }
    );

    observer.observe(element);

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      observer.disconnect();
    };
  }, []);

  return elementRef;
};
